import React, { useState } from 'react';
import { Container, Grid, TextField, Button, CssBaseline, Typography } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import { useTranslation } from 'react-i18next';
import { Formik, Form, FormikHelpers } from 'formik';
import { useSelector } from 'react-redux';
import { useEvaluationTemplateStyles } from './style';
import { FileUpload } from '../../components/fileUpload/fileUpload';
import { EvaluationTemplateModel } from '../../models/evaluationTemplateModel';
import { createEvaluationTemplateReq } from '../../api/evaulationTemplateApi';
import { ApplicationState } from '../../stores';

function EvaluationTemplate() {
  const evaluationTemplateStyles = useEvaluationTemplateStyles();
  const { t } = useTranslation();

  const [evaluationTemplateFile, setEvaluationTemplateFile] = useState<File>();
  const [keyValue, setKeyValue] = useState(0);
  const isLoading = useSelector<ApplicationState, boolean>(state => state.loader.loading);

  async function handleCreateEvaluationTemplate(
    values: EvaluationTemplateModel,
    actions: FormikHelpers<EvaluationTemplateModel>,
  ) {
    actions.resetForm();
    setKeyValue(keyValue + 1);

    await createEvaluationTemplateReq(values, evaluationTemplateFile);
    setEvaluationTemplateFile(undefined);
  }

  return (
    <Container maxWidth='lg'>
      <CssBaseline />
      <Grid item xs className={evaluationTemplateStyles.pageTitleGrid}>
        <Typography variant='h5'>{t('evaluation_template')}</Typography>
      </Grid>
      <Formik
        initialValues={{ title: '', version: '', file: { url: '' } } as EvaluationTemplateModel}
        enableReinitialize={true}
        onSubmit={handleCreateEvaluationTemplate}
      >
        {({ values, handleChange }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  variant='outlined'
                  margin='normal'
                  required
                  id='evaluation_template_title'
                  name='evaluation_template_title'
                  label={t('evaluation_template_title')}
                  className={evaluationTemplateStyles.textField}
                  value={values.title || ''}
                  onChange={handleChange('title')}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant='outlined'
                  margin='normal'
                  id='evaluation_template_version'
                  name='evaluation_template_version'
                  label={t('evaluation_template_version')}
                  className={evaluationTemplateStyles.textField}
                  value={values.version || ''}
                  onChange={handleChange('version')}
                />
              </Grid>
              <Grid item xs={12} style={{ marginTop: 50 }}>
                <FileUpload
                  filesLimit={1}
                  keyValue={keyValue}
                  fileUrl={values.file.url}
                  onChange={templateFile => {
                    setEvaluationTemplateFile(templateFile);
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs className={evaluationTemplateStyles.submitButtonGrid}>
              <Button
                type='submit'
                variant='contained'
                color='primary'
                size='large'
                className={evaluationTemplateStyles.button}
                startIcon={<SaveIcon />}
                disabled={!!(!evaluationTemplateFile || !values.title || isLoading)}
              >
                {t('save')}
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </Container>
  );
}

export default EvaluationTemplate;
